import React, {Component} from 'react';
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import {UncontrolledTooltip} from 'reactstrap';

class InternetSales extends Component {
	constructor(props) {
		super(props);
		this.state = {error: {}, internetSales: null};
		this.onChange = this.onChange.bind(this);
		this.validateField = this.validateField.bind(this);
		this.addInternetSales = this.addInternetSales.bind(this);
		this.removeInternetSales = this.removeInternetSales.bind(this);
	}

	componentWillMount() {
		this.setState({internetSales: this.props.internetSales});
	}

	addInternetSales(e) {
		let internetSales = {
			invoiceId: null,
			documentType: "KREDIKARTI/BANKAKARTI",
			documentId: "INTERNET_SATIS",
			issueDate: "",
			webSite: "",
			documentTypeCode: "ODEME_SEKLI",
			description: ""
		};
		this.props.listener(internetSales);
		this.setState({internetSales});
	}

	removeInternetSales(e, index) {
		this.setState({internetSales: null});
		this.props.listener(null);
	}

	onChange(e) {
		let internetSales = deepCopyObject(this.state.internetSales);
		internetSales[e.target.name] = e.target.value;
		if (internetSales.documentType !== "DIGER")
			internetSales.description = null;
		this.setState({internetSales});
		this.props.listener(internetSales);
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.error !== nextProps.error) {
			this.setState({error: nextProps.error});
		}

		if (nextProps.manual) {
			this.setState({internetSales: nextProps.internetSales, error: {}});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}

	render() {
		return (
			<div>
				{this.state.internetSales &&
                    <div className="row">
                        <div className="col-sm-12 row">
                            <div className="col-sm-6 row">
                                <label className="col-md-4 col-form-label">Ödeme Şekli* </label>
                                <div className="col-md-8">
                                    <div className={"form-group" + this.validateClass('SdocumentType')}>
                                        <Select
                                            id="SdocumentType"
                                            value={this.state.internetSales.documentType}
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => e && this.onChange({
                                                target: {
                                                    name: "documentType",
                                                    value: e.value
                                                }
                                            })}
                                            options={this.props.saleTypes.map(saleType => ({
                                                value: saleType.shortName,
                                                label: saleType.longName
                                            }))}
                                        />
                                        {this.validateMessage('SdocumentType') !== "" &&
                                        <UncontrolledTooltip placement="right" target="SdocumentType" delay={0}>
                                            {this.validateMessage("SdocumentType")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 row">
                                <label className="col-sm-4 col-form-label">Satış Web Sitesi </label>
                                <div className="col-sm-8">
                                    <div className={"form-group" + this.validateClass("SwebSite")}>
                                        <input className="form-control"
                                               type="text"
                                               data-vlength="0,255"
                                               data-vdata="url"
                                               id="SwebSite"
                                               name="webSite"
                                               onBlur={this.validateField}
                                               onChange={this.onChange}
                                               value={this.state.internetSales.webSite}/>
                                        {this.validateMessage("SwebSite") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"SwebSite"} delay={0}>
                                            {this.validateMessage("SwebSite")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            {this.state.internetSales.documentType === "DIGER" &&
                                <div className="col-sm-6 row">
                                    <label className="col-sm-4 col-form-label">Ödeme Detayı* </label>
                                    <div className="col-sm-8">
                                        <div className={"form-group" + this.validateClass("Sdescription")}>
                                            <input className="form-control"
                                                   type="text"
                                                   data-vlength="1,255"
                                                   id="Sdescription"
                                                   name="description"
                                                   onBlur={this.validateField}
                                                   onChange={this.onChange}
                                                   value={this.state.internetSales.description}/>
                                            {this.validateMessage("Sdescription") !== "" &&
                                            <UncontrolledTooltip placement="right" target={"Sdescription"} delay={0}>
                                                {this.validateMessage("Sdescription")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="col-sm-6 row">
                                <label className="col-sm-4 col-form-label">Ödeme Tarihi* </label>
                                <div className="col-sm-8">
                                    <div className={"form-group" + this.validateClass("SissueDate")}>
                                        <Datetime locale="tr"
                                                  className="datepicker"
                                                  input={true}
                                                  inputProps={{id: "SissueDate"}}
                                                  onBlur={(momentObj) => this.validateField({
                                                      target: {
                                                          id: "SissueDate",
                                                          dataset: {'vdata': "date", 'vlength': "1,255"},
                                                          value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                      }
                                                  })}
                                                  closeOnSelect={true}
                                                  value={moment(this.state.internetSales.issueDate, "YYYY-MM-DD", true).isValid() ? moment(this.state.internetSales.issueDate).format("DD-MM-YYYY") : this.state.internetSales.issueDate}
                                                  dateFormat="DD-MM-YYYY"
                                                  timeFormat={false}
                                                  isValidDate={function (current) {
                                                      return current.isBefore(Datetime.moment());
                                                  }}
                                                  onChange={(momentObj) => this.onChange({
                                                      target: {
                                                          name: 'issueDate',
                                                          value: (!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)
                                                      }
                                                  })}/>
                                        {this.validateMessage("SissueDate") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"SissueDate"} delay={0}>
                                            {this.validateMessage("SissueDate")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
				}
				{!this.state.internetSales &&
                    <div className="row">
                        <div className="col-sm-12">
                            <button type="button" rel="tooltip" onClick={(e) => this.addInternetSales(e)}
                                    data-placement="left"
                                    style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
                                    className="Btn ekle" data-original-title="İnternet Satış Bilgisi Ekle">
                            </button>
                        </div>
                    </div>
				}
				{this.state.internetSales &&
                    <div className="row">
                        <div className="col-sm-12">
                            <button type="button" rel="tooltip" onClick={(e) => this.removeInternetSales(e)}
                                    data-placement="left"
                                    style={{background: '#FFCCCC'}}
                                    className="Btn temizle" data-original-title="İnternet Satış Bilgisi Sil">
                            </button>
                        </div>
                    </div>
				}
			</div>
		);
	}
}

export default InternetSales;